// Import statements
import {
  configureStore,
  combineReducers,
} from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import userSlice from './slices/userSlice';
import categorySlice from './slices/categorySlice';
import groupSlice from './slices/groupSlice';
import locationSlice from './slices/locationSlice';
import editModeSlice from './slices/editModeSlice';
import tutorialEditSlice from './slices/tutorialEditSlice';
import conversationSlice from './slices/conversationSlice';
import positionSlice from './slices/positionSlice';

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'], // Specify reducers to persist
  stateReconciler: autoMergeLevel2,
};

// Combine reducers using slices created in respective files
const rootReducer = combineReducers({
  user: userSlice.reducer,
  category: categorySlice.reducer,
  group: groupSlice.reducer,
  location: locationSlice.reducer,
  editMode: editModeSlice,
  tutorialEdit: tutorialEditSlice,
  conversation: conversationSlice.reducer,
  position: positionSlice.reducer,
});

// Apply persistence to rootReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with Redux Toolkit
const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/PAUSE',
          'persist/PURGE',
          'persist/FLUSH',
          'persist/REGISTER',
        ],
      },
    }),
});

// Persistor for the store
const persistor = persistStore(store);

// Exports
export { store, persistor };
